/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, line: NonNullable<unknown> }} Einvoice_Draft_Field_LabelInputs */

const vi_einvoice_draft_field_label = /** @type {(inputs: Einvoice_Draft_Field_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} dòng ${i?.line}`)
};

/**

* @param {Einvoice_Draft_Field_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_field_label = /** @type {((inputs: Einvoice_Draft_Field_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Field_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_field_label(inputs)
});